import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FileText, ListChecks } from "lucide-react";

const items = [
  { path: "/", label: "Documents", icon: FileText, testid: "nav-documents" },
  { path: "/forms", label: "Form Builder", icon: ListChecks, testid: "nav-forms" },
];

const ModeNav = ({ accent = "#002FA7" }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className="mx-6 mt-4 grid grid-cols-2 gap-1 rounded-md bg-slate-100 p-1" data-testid="mode-nav">
      {items.map((it) => {
        const active = pathname === it.path;
        const Icon = it.icon;
        return (
          <button
            key={it.path}
            onClick={() => navigate(it.path)}
            className={`flex items-center justify-center gap-1.5 text-xs font-medium rounded py-1.5 transition-all ${active ? "text-white shadow-sm" : "text-slate-500 hover:text-slate-800"}`}
            style={active ? { background: accent } : {}}
            data-testid={it.testid}
          >
            <Icon size={13} /> {it.label}
          </button>
        );
      })}
    </div>
  );
};

export default ModeNav;
